import styled from '@emotion/styled'

export const LeftContentContainer = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
